export { default as excel } from './theme-excel';
export { default as ggplot2 } from './theme-ggplot2';
export { default as quartz } from './theme-quartz';
export { default as vox } from './theme-vox';
export { default as dark } from './theme-dark';
export { default as fivethirtyeight } from './theme-fivethirtyeight';
